// extracted by mini-css-extract-plugin
module.exports = {"container":"author_container__CrsSc","author-img":"author_author-img__ZEQzf","name":"author_name__AtI7T"};